import Vue from 'vue'
import { showNotice } from '@/utils/tool'
import { $langt } from '@/utils/i18n'

const orderItem = {
  item: null,
  productDetail: null,
  returnPath: '/',
  currencyCode: null,
  currencyDecimalPlace: 0,
  extraTaxRate: 0,
  init(item, productDetail, returnPath, currencyCode, currencyDecimalPlace, extraTaxRate) {
    this.item = item
    this.productDetail = productDetail
    this.returnPath = returnPath
    this.currencyCode = currencyCode
    this.currencyDecimalPlace = currencyDecimalPlace
    this.extraTaxRate = extraTaxRate
  },
  searchObj(targetArray, targetKey, matchValue) {
    for (var i = 0; i < targetArray.length; i++) {
      if ((targetArray[i][targetKey] += '') === (matchValue += '')) {
        return targetArray[i]
      }
    }

    return null
  },
  plan() {
    const result = this.searchObj(
      this.productDetail.plans,
      'plan_id',
      this.item.plans[0].plan_id
    )

    if (!result) {
      const self = this
      showNotice($langt('資料異常, 請重新處理'), function() {
        self.$router
          .push({ path: this.returnPath + self.item.item_id })
          .catch(() => {})
      })
    } else {
      return result
    }
  },
  price() {
    const result = this.searchObj(
      this.plan().prices,
      'price_id',
      this.item.plans[0].prices[0].price_id
    )

    if (!result) {
      const self = this
      showNotice($langt('資料異常, 請重新下單'), function() {
        self.$router.push({ path: this.returnPath }).catch(() => {})
      })
    } else {
      return result
    }
  },
  point() {
    return this.searchObj(
      this.price().points,
      'point_id',
      this.item.plans[0].prices[0].point_id
    )
  },
  pricePointLabel() {
    const point = this.point()
    if (point) {
      return (
        point.point + $langt('點') + ' + ' + Vue.filter('currencyTitle')(this.currencyCode) + Vue.filter('priceFormat')(point.sale_price, this.currencyCode)
      )
    } else {
      return Vue.filter('currencyTitle')(this.currencyCode) + Vue.filter('priceFormat')(this.price().sale_price, this.currencyCode)
    }
  },
  type() {
    return this.item.plans[0].prices[0].point_id ? 'point' : 'credit'
  },
  qty() {
    return this.item.plans[0].prices[0].qty
  },
  extraTax() {
    let value = this.price().sale_price * this.qty() * this.extraTaxRate
    let extraText = Math.round(value * (10 ** 8)) / (10 ** 8)
    return Math.round(extraText * (10 ** this.currencyDecimalPlace)) / (10 ** this.currencyDecimalPlace)
  },
  extraTaxLabel() {
    return Vue.filter('currencyTitle')(this.currencyCode) + Vue.filter('priceFormat')(this.extraTax(), this.currencyCode)
  },
  creditTotalPrice() {
    let value = this.price().sale_price * this.qty() + this.extraTax()
    return Math.round(value * (10 ** 8)) / (10 ** 8)
  },
  pointTotalPoint() {
    return this.point().point * this.qty()
  },
  pointTotalPrice() {
    return this.point().sale_price * this.qty()
  },
  priceName() {
    const result = this.searchObj(
      this.plan().prices,
      'price_id',
      this.item.plans[0].prices[0].price_id
    )
    if (!result) {
      const self = this
      showNotice($langt('資料異常, 請重新下單'), function() {
        self.$router.push({ path: this.returnPath }).catch(() => {})
      })
    } else {
      return result.price_name
    }
  }
}
export default orderItem
